import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Pos } from '@/dto/pos/pos';

@Injectable({ providedIn: 'root' })
export class PosService {
  constructor(private http: HttpClient) {
  }

  get(page: number, size: number, dataFilter : Pos, sortCol: string, sortDir: string): Observable<any> {
    let  params = new HttpParams().append('page', page.toString()).append('size', size.toString())
    .append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString());
    if(dataFilter) {
      Object.keys(dataFilter).forEach(item => {
        params = params.append(item.toString(), dataFilter[item]?.toString() || '')
      })
    }

    return this.http.get(environment.apiUrl + '/dashboard/pos', { params: params}).pipe(map(data => data));
  }

  getListNetWork () : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/network').pipe(map(data => data));
  }

  getByNetwork_reference(network_reference: string) : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/pos/'+network_reference).pipe(map(data => data));
  }
}
